/* MOOOD — core theme script (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------------------
     Focus trap + drawers (menu, cart)
     ------------------------------------------------------------------------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var openLayer = null;
  var lastTrigger = null;

  function trap(e) {
    if (!openLayer || e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, openLayer).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer(el, trigger) {
    if (!el) return;
    if (openLayer && openLayer !== el) closeLayer();
    lastTrigger = trigger || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openLayer = el;
    var focusTarget = $('[data-autofocus]', el) || $('[data-drawer-close]:not(.drawer__overlay)', el) || $(FOCUSABLE, el);
    setTimeout(function () { if (focusTarget) focusTarget.focus(); }, 60);
  }

  function closeLayer() {
    if (!openLayer) return;
    var el = openLayer;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('is-locked');
    openLayer = null;
    if (lastTrigger && document.contains(lastTrigger)) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) { lastTrigger.focus(); } }
    if (el.hasAttribute('data-search-modal')) el.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLayer) closeLayer();
    trap(e);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen), opener); return; }
    if (e.target.closest('[data-drawer-close], [data-upsell-close]')) { e.preventDefault(); closeLayer(); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(e.target.closest('[data-search-open]')); return; }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeLayer(); return; }
    var cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && T.cartType !== 'page' && document.getElementById('CartDrawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer(document.getElementById('CartDrawer'), cartLink);
    }
  });

  /* ---------------------------------------------------------------------------
     Sticky header shadow
     ------------------------------------------------------------------------- */
  var header = $('[data-header]');
  if (header) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------------------------------------------------------------------------
     Search overlay: popular + recent searches, trending list, live results
     (Section Rendering "search-live" — works in Arabic, unlike predictive search)
     ------------------------------------------------------------------------- */
  var searchModal = $('[data-search-modal]');
  var RECENT_KEY = 'moood-recent-searches';
  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').slice(0, 6); } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    var list = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  }
  function renderRecent() {
    var box = $('[data-search-recent]', searchModal);
    var listEl = $('[data-search-recent-list]', searchModal);
    if (!box || !listEl) return;
    var list = readRecent();
    box.hidden = !list.length;
    listEl.innerHTML = '';
    list.forEach(function (q) {
      var a = document.createElement('a');
      a.className = 'search-chip search-chip--recent';
      a.href = T.routes.search + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
      a.setAttribute('data-search-term', q);
      a.textContent = q;
      listEl.appendChild(a);
    });
  }

  var trendingLoaded = false;
  function loadTrending() {
    if (trendingLoaded || !searchModal) return;
    var box = $('[data-search-trending]', searchModal);
    if (!box) return;
    trendingLoaded = true;
    fetch(box.dataset.url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var list = doc.querySelector('.prow-list');
      if (!list || !list.children.length) { box.closest('.search-block').hidden = true; return; }
      box.innerHTML = '';
      box.appendChild(document.importNode(list, true));
      staggerIn(box);
      processKnockouts(box);
    }).catch(function () { trendingLoaded = false; });
  }

  function staggerIn(root) {
    $$('.prow, .search-chip, .search-all', root).forEach(function (el, i) {
      el.style.setProperty('--i', Math.min(i, 8));
      el.classList.add('is-entering');
    });
  }

  function openSearch(trigger) {
    if (!searchModal) { location.href = T.routes.search; return; }
    lastTrigger = trigger;
    if (openLayer) closeLayer();
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    openLayer = searchModal;
    document.body.classList.add('is-locked');
    renderRecent();
    loadTrending();
    var input = $('[data-search-input]', searchModal);
    // Focus synchronously inside the tap so iOS opens the keyboard
    if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
  }

  if (searchModal) {
    searchModal.addEventListener('click', function (e) { if (e.target === searchModal) closeLayer(); });
    var sInput = $('[data-search-input]', searchModal);
    var sResults = $('[data-search-results]', searchModal);
    var sClear = $('[data-search-clear]', searchModal);
    var sForm = $('[data-search-form]', searchModal);
    var sTimer, sController, sLast = '';

    var setQueryMode = function (on) { searchModal.classList.toggle('has-query', on); };

    // Arabic -> catalogue language (titles are mostly Latin): "عطر سوفاج" -> "sauvage"
    var normAr = function (t) {
      return t.replace(/[\u064B-\u0652\u0640]/g, '').replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي').toLowerCase();
    };
    var synonyms = [];
    if (sForm && sForm.dataset.synonyms) {
      sForm.dataset.synonyms.split(/\r?\n/).forEach(function (line) {
        var i = line.indexOf('=');
        if (i < 1) return;
        var k = normAr(line.slice(0, i).trim()), v = line.slice(i + 1).trim();
        if (k && v) synonyms.push([k, v]);
      });
      synonyms.sort(function (a, b) { return b[0].length - a[0].length; });
    }
    var FILLER = /(^|\s)(عطر|عطور|برفيوم|بارفيوم|او دو|للرجال|رجالي|نسائي|للنساء|اصلي)(?=\s|$)/g;
    var mapQuery = function (q) {
      if (!/[\u0600-\u06FF]/.test(q) || !synonyms.length) return q;
      var n = ' ' + normAr(q) + ' ', hit = false;
      synonyms.forEach(function (p) {
        if (n.indexOf(p[0]) > -1) { n = n.split(p[0]).join(' ' + p[1] + ' '); hit = true; }
      });
      if (!hit) return q;
      // Titles are Latin: once something was translated, drop leftover Arabic words
      var out = n.replace(FILLER, ' ').split(/\s+/).filter(function (w) { return w && !/[\u0600-\u06FF]/.test(w); }).join(' ');
      return out || q;
    };

    var sUsed = '';
    var fetchLive = function (q, signal) {
      var url = T.routes.search + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=search-live';
      return fetch(url, signal ? { signal: signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('.shopify-section') || doc.body;
          return { q: q, sec: sec, empty: !sec.querySelector('.prow') };
        });
    };
    // Search the words as typed; if nothing matches and they're Arabic, retry with the translated query
    var liveSearch = function (q) {
      if (q === sLast) return;
      sLast = q;
      if (sController) sController.abort();
      sController = 'AbortController' in window ? new AbortController() : null;
      var signal = sController && sController.signal;
      searchModal.classList.add('is-searching');
      var alt = mapQuery(q);
      fetchLive(q, signal)
        .then(function (res) {
          if (res.empty && alt !== q) return fetchLive(alt, signal).then(function (r2) { return r2.empty ? res : r2; });
          return res;
        })
        .then(function (res) {
          if (sInput.value.trim() !== q) return;
          sUsed = res.q;
          sResults.innerHTML = res.sec.innerHTML;
          setQueryMode(true);
          staggerIn(sResults);
          processKnockouts(sResults);
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') sLast = ''; })
        .finally(function () { searchModal.classList.remove('is-searching'); });
    };

    var onInput = function () {
      var q = sInput.value.trim();
      if (sClear) sClear.hidden = !sInput.value;
      clearTimeout(sTimer);
      if (!q) { sLast = ''; setQueryMode(false); sResults.innerHTML = ''; return; }
      sTimer = setTimeout(function () { liveSearch(q); }, 220);
    };
    if (sInput && sResults) sInput.addEventListener('input', onInput);

    if (sClear) sClear.addEventListener('click', function () {
      sInput.value = '';
      onInput();
      sInput.focus();
    });

    searchModal.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-search-term]');
      if (chip) {
        e.preventDefault();
        sInput.value = chip.dataset.searchTerm;
        if (sClear) sClear.hidden = false;
        saveRecent(chip.dataset.searchTerm);
        clearTimeout(sTimer);
        liveSearch(sInput.value.trim());
        return;
      }
      if (e.target.closest('[data-search-recent-clear]')) {
        try { localStorage.removeItem(RECENT_KEY); } catch (err) {}
        renderRecent();
        return;
      }
      if (e.target.closest('.search-live a, .search-trending a')) saveRecent(sInput.value);
    });

    if (sForm) sForm.addEventListener('submit', function (e) {
      var q = sInput.value.trim();
      if (!q) { e.preventDefault(); sInput.focus(); return; }
      saveRecent(q);
      // Full results page: use the query that actually found products in the live panel
      if (sUsed && sUsed !== q && sLast === q) sInput.value = sUsed;
    });
  }

  /* ---------------------------------------------------------------------------
     Toast
     ------------------------------------------------------------------------- */
  var toastEl = $('[data-toast]');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 3500);
  }
  T.toast = toast;

  /* ---------------------------------------------------------------------------
     Cart (AJAX API + Section Rendering) and Cart Drawer
     ------------------------------------------------------------------------- */
  function cartDrawer() { return document.getElementById('CartDrawer'); }

  function renderCartSections(sections) {
    if (!sections) return;
    var activeId = document.activeElement && document.activeElement.id;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]');
      var n = fresh ? parseInt(fresh.dataset.count, 10) || 0 : 0;
      if (fresh && current) {
        current.replaceWith(fresh);
        processKnockouts(fresh);
      }
      updateCount(n);
    }
    var pageHtml = sections['main-cart'];
    var pageRoot = $('[data-main-cart]');
    if (pageHtml && pageRoot) {
      var doc2 = new DOMParser().parseFromString(pageHtml, 'text/html');
      var freshPage = doc2.querySelector('[data-main-cart]');
      if (freshPage) { pageRoot.replaceWith(freshPage); processKnockouts(freshPage); }
    }
    freeShipping();
    if (activeId) {
      var again = document.getElementById(activeId);
      if (again) again.focus();
      else if (openLayer) { var c = $('[data-drawer-close]:not(.drawer__overlay)', openLayer); if (c) c.focus(); }
    }
  }

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    $$('[data-cart-link]').forEach(function (a) {
      var label = a.getAttribute('aria-label') || '';
      a.setAttribute('aria-label', label.replace(/\d+/, n));
    });
  }

  function sectionsToRender() {
    var list = ['cart-drawer'];
    if ($('[data-main-cart]')) list.push('main-cart');
    return list;
  }

  function freeShipping() {
    $$('[data-free-ship]').forEach(function (box) {
      var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
      var threshold = Math.round((T.freeShippingThreshold || 0) * rate);
      var total = parseInt(box.dataset.total, 10) || 0;
      if (!threshold) { box.hidden = true; return; }
      var text = $('[data-free-ship-text]', box);
      var bar = $('[data-free-ship-bar]', box);
      var remaining = Math.max(0, threshold - total);
      if (bar) bar.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
      if (text) {
        if (remaining === 0) text.textContent = T.strings.freeShippingDone;
        else text.textContent = T.strings.freeShippingRemaining.replace('[amount]', formatMoney(remaining, box.dataset.currencyLabel));
      }
      box.hidden = false;
    });
  }

  function formatMoney(cents, label) {
    var v = cents / 100;
    var num = (Math.round(v * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return num + ' ' + (label || (window.Shopify && Shopify.currency && Shopify.currency.active) || '');
  }

  function addToCart(form) {
    var btn = $('[type="submit"]', form);
    var fd = new FormData(form);
    fd.append('sections', sectionsToRender().join(','));
    fd.append('sections_url', location.pathname);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var errBox = form.querySelector('[data-form-error]');
    if (errBox) { errBox.hidden = true; errBox.textContent = ''; }

    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok || res.data.status) {
        var msg = (res.data && (res.data.description || res.data.message)) || T.strings.cartError;
        if (errBox) { errBox.textContent = msg; errBox.hidden = false; } else toast(msg);
        return;
      }
      var upsell = document.getElementById('UpsellSheet');
      var mode = T.cartType === 'upsell' && upsell ? 'upsell' : (T.cartType !== 'page' && cartDrawer() ? 'drawer' : 'page');
      if (mode === 'page') { location.href = T.routes.cart; return; }
      if (btn) {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 2400);
      }
      var info = mode === 'upsell' ? addedInfo(form, res.data) : null;
      renderCartSections(res.data.sections);
      document.dispatchEvent(new CustomEvent('moood:cart-added', { detail: res.data }));
      var card = form.closest('[data-product-card]');
      var srcImg = card ? card.querySelector('.card__media img:not(.card__img--hover)') : document.querySelector('.gallery__slide.is-active img, .gallery__slide img');
      if (mode === 'upsell') {
        var recs = fetchUpsell(res.data.product_id);
        flyToCart(srcImg).then(function () { openUpsell(info, recs, btn); });
      } else {
        flyToCart(srcImg).then(function () {
          setTimeout(function () { openDrawer(cartDrawer(), btn); }, 180);
        });
      }
    }).catch(function () {
      toast(T.strings.cartError);
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function visibleCartIcon() {
    return $$('[data-cart-link]').filter(function (a) { var r = a.getBoundingClientRect(); return r.width && r.bottom > 0; })[0];
  }

  function bump(el) {
    if (!el) return;
    el.classList.remove('is-bumping'); void el.offsetWidth; el.classList.add('is-bumping');
    setTimeout(function () { el.classList.remove('is-bumping'); }, 700);
  }

  function flyToCart(img) {
    var target = visibleCartIcon();
    if (reduceMotion || !img || !target || !img.animate) { bump(target); return Promise.resolve(); }
    var a = img.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    if (!a.width) { bump(target); return Promise.resolve(); }
    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.alt = '';
    ghost.className = 'fly-ghost';
    ghost.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;';
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 90) + 'px) scale(.55)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: 0.2 }
    ], { duration: 850, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' });
    return new Promise(function (resolve) {
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        ghost.remove();
        bump(target);
        bump($('[data-cart-count]', target));
        resolve();
      };
      anim.onfinish = finish;
      setTimeout(finish, 1100); // background tabs pause animations; never block the drawer
    });
  }

  /* ---------------------------------------------------------------------------
     "Added to bag" sheet with suggestions (cart_type = upsell)
     ------------------------------------------------------------------------- */
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function txt(root, sel) { var el = root && root.querySelector(sel); return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function addedInfo(form, item) {
    var card = form.closest('[data-product-card]');
    var page = form.closest('moood-product') || document.querySelector('moood-product');
    var info = { brand: '', name: item.product_title, meta: '', img: item.image, stage: '', qty: item.quantity || 1, price: item.final_price };
    if (card) {
      info.brand = txt(card, '.card__brand');
      info.name = txt(card, '.card__title') || info.name;
      info.meta = txt(card, '.card__meta');
      var media = card.querySelector('.card__media');
      var im = media && media.querySelector('img:not(.card__img--hover)');
      if (media) info.stage = media.classList.contains('ko-done') ? 'cut' : media.classList.contains('ko-skip') ? 'cover' : media.classList.contains('ko-failed') || media.classList.contains('card__media--cream') ? 'cream' : '';
      if (im && info.stage) info.img = im.currentSrc || im.src;
    } else if (page) {
      info.brand = txt(page, '.product__brand');
      info.name = txt(page, '.product__title') || info.name;
      var sizeEl = page.querySelector('.product__specs li');
      info.meta = sizeEl ? sizeEl.textContent.replace(/\s+/g, ' ').trim() : (item.variant_title || '');
      var slide = page.querySelector('.gallery__slide');
      if (slide && slide.classList.contains('ko-failed')) info.stage = 'cream';
    }
    return info;
  }

  function upsellEl() { return document.getElementById('UpsellSheet'); }

  function fetchUpsell(productId) {
    if (!T.routes.recommendations) return Promise.resolve(null);
    var url = T.routes.recommendations + '?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related&section_id=cart-upsell';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-upsell-items] .prow-list');
    }).catch(function () { return null; });
  }

  function cartState() {
    var inner = $('[data-cart-drawer-inner]');
    return {
      total: inner ? parseInt(inner.dataset.total, 10) || 0 : 0,
      count: inner ? parseInt(inner.dataset.count, 10) || 0 : 0
    };
  }

  function thresholdCents() {
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    return Math.round((T.freeShippingThreshold || 0) * rate);
  }

  function refreshUpsell() {
    var sheet = upsellEl();
    if (!sheet) return;
    var st = cartState();
    var totalEl = $('[data-upsell-total]', sheet);
    if (totalEl) totalEl.textContent = formatMoney(st.total, T.currencyLabel);
    var countEl = $('[data-upsell-count]', sheet);
    if (countEl) countEl.textContent = '(' + st.count + ')';
    var ship = $('[data-upsell-ship]', sheet);
    if (ship) ship.dataset.total = st.total;
    freeShipping();
    // Honest nudge: tag suggestions whose price alone unlocks free delivery
    var remaining = Math.max(0, thresholdCents() - st.total);
    $$('.prow--upsell', sheet).forEach(function (row) {
      var tag = row.querySelector('[data-unlock-tag]');
      if (!tag) return;
      var price = parseInt(row.dataset.price, 10) || 0;
      tag.hidden = !(remaining > 0 && price >= remaining && !row.classList.contains('is-added'));
    });
  }

  function openUpsell(info, recsPromise, trigger) {
    var sheet = upsellEl();
    if (!sheet) return;
    var added = $('[data-upsell-added]', sheet);
    if (added && info) {
      var qty = info.qty > 1 ? ' · ' + esc(T.strings.upsellQty.replace('[qty]', info.qty)) : '';
      // Not yet processed on the page: use the CDN image and cut it out here
      var needsKo = !info.stage && document.documentElement.dataset.koThreshold && info.img && info.img.indexOf('blob:') !== 0;
      var src = info.img;
      if (needsKo && /cdn\.shopify|\/cdn\/shop\//.test(src)) src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      added.innerHTML =
        '<span class="sheet__added-media' + (info.stage ? ' is-' + info.stage : '') + (needsKo ? ' knockout' : '') + '">' +
          (src ? '<img src="' + esc(src) + '" alt="" width="120" height="150">' : '') +
        '</span>' +
        '<span class="sheet__added-info">' +
          (info.brand ? '<span class="sheet__added-brand">' + esc(info.brand) + '</span>' : '') +
          '<span class="sheet__added-name">' + esc(info.name) + '</span>' +
          '<span class="sheet__added-meta">' + (info.meta ? esc(info.meta) + ' · ' : '') + '<strong>' + esc(formatMoney(info.price, T.currencyLabel)) + '</strong>' + qty + '</span>' +
        '</span>';
    }
    if (added) processKnockouts(added);
    var recsBox = $('[data-upsell-recs]', sheet);
    var recsWrap = $('[data-upsell-recs-wrap]', sheet);
    if (recsWrap) recsWrap.hidden = false;
    if (recsBox && !recsBox.dataset.skeleton) recsBox.dataset.skeleton = recsBox.innerHTML;
    if (recsBox) recsBox.innerHTML = recsBox.dataset.skeleton;
    var body = $('[data-upsell-body]', sheet);
    if (body) body.scrollTop = 0;
    refreshUpsell();
    sheet.classList.remove('is-dragging');
    $('[data-upsell-panel]', sheet).style.transform = '';
    openDrawer(sheet, trigger);
    sheet.classList.remove('is-played'); void sheet.offsetWidth; sheet.classList.add('is-played');

    Promise.resolve(recsPromise).then(function (list) {
      if (!recsBox) return;
      if (!list || !list.children.length) { if (recsWrap) recsWrap.hidden = true; return; }
      recsBox.innerHTML = '';
      recsBox.appendChild(document.importNode(list, true));
      staggerIn(recsBox);
      processKnockouts(recsBox);
      refreshUpsell();
    });
  }

  function upsellAdd(form) {
    var btn = $('button', form);
    var row = form.closest('.prow');
    if (!btn || btn.classList.contains('is-added')) return;
    btn.classList.add('is-loading');
    var fd = new FormData(form);
    fd.append('sections', sectionsToRender().join(','));
    fd.append('sections_url', location.pathname);
    fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    }).then(function (res) {
      if (!res.ok || res.data.status) { toast(res.data.description || res.data.message || T.strings.cartError); return; }
      renderCartSections(res.data.sections);
      btn.classList.add('is-added');
      btn.setAttribute('aria-disabled', 'true');
      if (row) row.classList.add('is-added');
      refreshUpsell();
      bump(visibleCartIcon());
      $$('[data-cart-count]').forEach(bump);
      document.dispatchEvent(new CustomEvent('moood:cart-added', { detail: res.data }));
    }).catch(function () { toast(T.strings.cartError); })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-upsell-add]')) return;
    e.preventDefault();
    upsellAdd(f);
  });

  document.addEventListener('click', function (e) {
    var view = e.target.closest('[data-upsell-view-cart]');
    if (!view || !cartDrawer() || document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    closeLayer();
    setTimeout(function () { openDrawer(cartDrawer(), view); }, 260);
  });

  /* Swipe the sheet down to dismiss (phones) */
  (function () {
    var sheet = upsellEl();
    if (!sheet) return;
    var panel = $('[data-upsell-panel]', sheet);
    var body = $('[data-upsell-body]', sheet);
    var startY = 0, dy = 0, active = false;
    panel.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 750) return;
      var fromGrab = e.target.closest('[data-upsell-grab], .sheet__head');
      if (!fromGrab && body && body.scrollTop > 0) return;
      active = true; dy = 0; startY = e.touches[0].clientY;
      sheet.classList.add('is-dragging');
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!active) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    var end = function () {
      if (!active) return;
      active = false;
      sheet.classList.remove('is-dragging');
      panel.style.transform = '';
      if (dy > 110) closeLayer();
    };
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  })();

  /* ---------------------------------------------------------------------------
     Product page: sticky add-to-cart bar (phones)
     ------------------------------------------------------------------------- */
  (function () {
    var bar = $('[data-sticky-atc]');
    if (!bar) return;
    var root = bar.closest('moood-product');
    var buy = root && root.querySelector('.buy');
    var formId = root && root.dataset.formId;
    if (!buy || !formId) { bar.remove(); return; }
    document.body.classList.add('has-sticky-atc');
    var mainBtn = function () { var f = document.getElementById(formId); return f && f.querySelector('[type="submit"]'); };
    var sync = function () {
      var price = root.querySelector('.product__price .price, .product__price .money');
      var target = $('[data-sticky-price]', bar);
      if (price && target) target.innerHTML = price.innerHTML;
      var b = mainBtn(), sb = $('[data-sticky-add]', bar);
      if (b && sb) {
        sb.disabled = b.disabled;
        var label = b.querySelector('.btn-cart__label');
        if (label) sb.querySelector('span').textContent = label.textContent.trim();
      }
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (show) sync();
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('sticky-atc-on', show);
      }).observe(buy);
    }
    $('[data-sticky-add]', bar).addEventListener('click', function () {
      var b = mainBtn();
      if (b && !b.disabled) b.click();
    });
  })();

  /* Scroll reveal */
  var REVEAL = '.section-head, .product-grid > li, .cats__grid > li, .why__intro, .why__item, .review, .gift__content > *, .gift__media, .newsletter__inner > *, .footer__grid > *, .collection-hero, .reviews__head';
  var revealIO = (!reduceMotion && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      revealIO.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;

  function reveal(root) {
    if (!revealIO) return;
    var counters = new Map();
    $$(REVEAL, root || document).forEach(function (el) {
      if (el.hasAttribute('data-reveal') || el.classList.contains('skeleton')) return;
      var parent = el.parentNode;
      var i = counters.get(parent) || 0;
      counters.set(parent, i + 1);
      el.style.setProperty('--i', i % 4);
      el.setAttribute('data-reveal', '');
      revealIO.observe(el);
    });
  }
  T.reveal = reveal;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    addToCart(form);
  });

  function changeLine(line, qty) {
    var drawer = cartDrawer();
    if (drawer) drawer.classList.add('is-busy');
    var root = $('[data-main-cart]');
    if (root) root.classList.add('is-busy');
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: sectionsToRender(), sections_url: location.pathname })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    }).then(function (res) {
      if (!res.ok || res.data.status) { toast(res.data.description || res.data.message || T.strings.cartError); return; }
      renderCartSections(res.data.sections);
    }).catch(function () { toast(T.strings.cartError); })
      .finally(function () {
        var d = cartDrawer(); if (d) d.classList.remove('is-busy');
        var r2 = $('[data-main-cart]'); if (r2) r2.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var qBtn = e.target.closest('[data-line-qty]');
    if (qBtn) {
      e.preventDefault();
      changeLine(parseInt(qBtn.dataset.line, 10), parseInt(qBtn.dataset.lineQty, 10));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (input) changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });

  /* Product-page quantity steppers */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10);
    input.value = Math.max(1, v);
  });

  /* ---------------------------------------------------------------------------
     Knockout — removes a white studio background in the browser so product
     photos sit on the black theme. Only white connected to the image border is
     removed (flood fill), so white labels inside the bottle survive.
     Runs in a Web Worker (OffscreenCanvas) when possible; results cached with
     the Cache API. Any failure falls back to a cream stage (.ko-failed).
     ------------------------------------------------------------------------- */
  var KO_T = parseInt(document.documentElement.dataset.koThreshold, 10) || 228;
  var KO_CACHE = 'moood-ko-v3-' + KO_T;

  var koAlgo = function (data, w, h, T0) {
    // data: Uint8ClampedArray RGBA (modified in place).
    // Returns { s: 'skip' | 'fail' | 'done', box: [x, y, w, h] } — box = padded product bounds for tight cropping.
    var n = w * h, i, p, x, y;
    var border = 0, white = 0, transparent = 0;
    function checkPx(cx, cy) {
      var k = (cy * w + cx) * 4;
      border++;
      if (data[k + 3] < 200) { transparent++; return; }
      var mn = Math.min(data[k], data[k + 1], data[k + 2]);
      var mx = Math.max(data[k], data[k + 1], data[k + 2]);
      if (mn >= T0 && mx - mn < 22) white++;
    }
    for (i = 0; i < w; i += 2) { checkPx(i, 0); checkPx(i, h - 1); }
    for (i = 0; i < h; i += 2) { checkPx(0, i); checkPx(w - 1, i); }

    var mask = new Uint8Array(n); // 1 = background
    var isClear = transparent / border > 0.5;
    if (isClear) {
      // Already a cut-out PNG: nothing to remove, only measure bounds.
      for (p = 0; p < n; p++) if (data[p * 4 + 3] < 20) mask[p] = 1;
    } else {
      if (white / border < 0.6) return { s: 'skip' };
      // Flood fill from every white border pixel (edge-aware: stop at contrast steps)
      var queue = new Int32Array(n);
      var qh = 0, qt = 0;
      var lum = function (k) { return (data[k] * 3 + data[k + 1] * 6 + data[k + 2]) / 10; };
      var isBg = function (k) {
        if (data[k + 3] < 20) return true;
        var mn = Math.min(data[k], data[k + 1], data[k + 2]);
        var mx = Math.max(data[k], data[k + 1], data[k + 2]);
        return mn >= T0 && (mx - mn) < 26;
      };
      var seed = function (sx, sy) {
        var sp = sy * w + sx;
        if (!mask[sp] && isBg(sp * 4)) { mask[sp] = 1; queue[qt++] = sp; }
      };
      for (i = 0; i < w; i++) { seed(i, 0); seed(i, h - 1); }
      for (i = 0; i < h; i++) { seed(0, i); seed(w - 1, i); }
      while (qh < qt) {
        p = queue[qh++];
        x = p % w; y = (p - x) / w;
        var lp = lum(p * 4);
        var nb = [x > 0 ? p - 1 : -1, x < w - 1 ? p + 1 : -1, y > 0 ? p - w : -1, y < h - 1 ? p + w : -1];
        for (var j = 0; j < 4; j++) {
          var q = nb[j];
          if (q < 0 || mask[q]) continue;
          var kq = q * 4;
          if (isBg(kq) && Math.abs(lum(kq) - lp) < 14) { mask[q] = 1; queue[qt++] = q; }
        }
      }
    }

    // Measure the product: bounds + per-row / per-column extents
    var rowMin = new Int32Array(h).fill(w), rowMax = new Int32Array(h).fill(-1);
    var colMin = new Int32Array(w).fill(h), colMax = new Int32Array(w).fill(-1);
    var rowCnt = new Int32Array(h), colCnt = new Int32Array(w);
    var fg = 0, fgWhite = 0, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        if (mask[y * w + x]) continue;
        fg++; rowCnt[y]++; colCnt[x]++;
        var kw = (y * w + x) * 4;
        if (Math.min(data[kw], data[kw + 1], data[kw + 2]) >= 216) fgWhite++;
        if (x < rowMin[y]) rowMin[y] = x;
        if (x > rowMax[y]) rowMax[y] = x;
        if (y < colMin[x]) colMin[x] = y;
        if (y > colMax[x]) colMax[x] = y;
      }
    }
    // Bounds ignore stray specks (rows/columns with only a few leftover pixels)
    var rT = Math.max(2, w * 0.006), cT = Math.max(2, h * 0.006);
    for (y = 0; y < h; y++) if (rowCnt[y] >= rT) { if (y < y0) y0 = y; y1 = y; }
    for (x = 0; x < w; x++) if (colCnt[x] >= cT) { if (x < x0) x0 = x; x1 = x; }
    if (x1 < 0 || y1 < 0) return { s: 'fail' };

    // Safety 1: almost nothing left (white product on a white backdrop)
    if (fg / n < 0.07) return { s: 'fail' };

    if (!isClear) {
      // Safety 2: background "leaked" inside the product (e.g. a white gift box):
      // removed pixels that sit inside the product both horizontally and vertically.
      var holes = 0;
      for (y = y0; y <= y1; y++) {
        if (rowMax[y] < 0) continue;
        for (x = rowMin[y] + 1; x < rowMax[y]; x++) {
          if (mask[y * w + x] && y > colMin[x] && y < colMax[x]) holes++;
        }
      }
      var hr = holes / fg;
      // Heavy leak, or a mostly-white product (gift box) with a moderate leak -> safe fallback stage
      // ...or a sparse, broken-up shape with a leak (box partly eaten away)
      var fill = fg / ((x1 - x0 + 1) * (y1 - y0 + 1));
      if (hr > 0.16 || (hr >= 0.05 && fgWhite / fg >= 0.35) || (hr >= 0.04 && fill < 0.45)) return { s: 'fail' };

      // Apply: background -> transparent; 1px soft edge with white decontamination
      for (p = 0; p < n; p++) {
        var k = p * 4;
        if (mask[p]) { data[k + 3] = 0; continue; }
        var x2 = p % w, y2 = (p - x2) / w;
        var edge = (x2 > 0 && mask[p - 1]) || (x2 < w - 1 && mask[p + 1]) || (y2 > 0 && mask[p - w]) || (y2 < h - 1 && mask[p + w]);
        if (!edge) continue;
        var mn2 = Math.min(data[k], data[k + 1], data[k + 2]);
        var a = Math.max(0.25, Math.min(1, (255 - mn2) / (255 - T0 + 30)));
        for (var c = 0; c < 3; c++) {
          data[k + c] = Math.max(0, Math.min(255, (data[k + c] - 255 * (1 - a)) / a));
        }
        data[k + 3] = Math.round(data[k + 3] * a);
      }
    }

    // Padded crop box so every product fills its frame the same way
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1;
    var pad = Math.round(Math.max(bw, bh) * 0.025);
    var cx0 = Math.max(0, x0 - pad), cy0 = Math.max(0, y0 - pad);
    var cx1 = Math.min(w - 1, x1 + pad), cy1 = Math.min(h - 1, y1 + pad);
    return { s: 'done', box: [cx0, cy0, cx1 - cx0 + 1, cy1 - cy0 + 1] };
  };

  var worker = null;
  var workerJobs = {};
  var jobId = 0;
  function getWorker() {
    if (worker !== null) return worker;
    worker = false;
    if (!('OffscreenCanvas' in window) || !('Worker' in window) || !('createImageBitmap' in window)) return worker;
    try {
      var src =
        'var ko=' + koAlgo.toString() + ';' +
        'self.onmessage=async function(e){var d=e.data;try{' +
        'var r=await fetch(d.url,{mode:"cors",credentials:"omit"});if(!r.ok)throw 0;' +
        'var bmp=await createImageBitmap(await r.blob());var w=bmp.width,h=bmp.height;' +
        'var c=new OffscreenCanvas(w,h);var x=c.getContext("2d",{willReadFrequently:true});x.drawImage(bmp,0,0);' +
        'var img=x.getImageData(0,0,w,h);var res=ko(img.data,w,h,d.t);' +
        'if(res.s!=="done"){self.postMessage({id:d.id,status:res.s});return;}' +
        'x.putImageData(img,0,0);' +
        'if(d.crop&&res.box){var b=res.box;var c2=new OffscreenCanvas(b[2],b[3]);c2.getContext("2d").drawImage(c,b[0],b[1],b[2],b[3],0,0,b[2],b[3]);c=c2;}' +
        'var o;try{o=await c.convertToBlob({type:"image/webp",quality:0.9});if(o.type!=="image/webp")throw 0;}catch(_){o=await c.convertToBlob({type:"image/png"});}' +
        'self.postMessage({id:d.id,status:"done",blob:o});' +
        '}catch(err){self.postMessage({id:d.id,status:"error"});}};';
      worker = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
      worker.onmessage = function (e) {
        var job = workerJobs[e.data.id];
        delete workerJobs[e.data.id];
        if (job) job(e.data);
      };
      worker.onerror = function () { worker = false; };
    } catch (e) { worker = false; }
    return worker;
  }

  function processOnMainThread(url, crop) {
    return new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () {
        var run = function () {
          try {
            var c = document.createElement('canvas');
            c.width = im.naturalWidth; c.height = im.naturalHeight;
            var x = c.getContext('2d', { willReadFrequently: true });
            x.drawImage(im, 0, 0);
            var d = x.getImageData(0, 0, c.width, c.height);
            var res = koAlgo(d.data, c.width, c.height, KO_T);
            if (res.s !== 'done') return resolve({ status: res.s });
            x.putImageData(d, 0, 0);
            if (crop && res.box) {
              var b = res.box, c2 = document.createElement('canvas');
              c2.width = b[2]; c2.height = b[3];
              c2.getContext('2d').drawImage(c, b[0], b[1], b[2], b[3], 0, 0, b[2], b[3]);
              c = c2;
            }
            c.toBlob(function (b) { resolve(b ? { status: 'done', blob: b } : { status: 'error' }); }, 'image/png');
          } catch (e) { resolve({ status: 'error' }); }
        };
        ('requestIdleCallback' in window) ? requestIdleCallback(run, { timeout: 1500 }) : setTimeout(run, 16);
      };
      im.onerror = function () { resolve({ status: 'error' }); };
      im.src = url;
    });
  }

  function knockoutUrl(url, crop) {
    var key = new URL(url, location.href).toString();
    var cacheName = KO_CACHE + (crop ? '-crop' : '');
    var cachePromise = ('caches' in window)
      ? caches.open(cacheName).then(function (c) {
          return c.match(key).then(function (hit) {
            if (!hit) return null;
            var st = hit.headers.get('x-ko');
            if (st === 'skip' || st === 'fail') return { status: st };
            return hit.blob().then(function (b) { return { status: 'done', blob: b }; });
          });
        }).catch(function () { return null; })
      : Promise.resolve(null);

    return cachePromise.then(function (hit) {
      if (hit) return hit;
      var w = getWorker();
      var job = w
        ? new Promise(function (resolve) {
            var id = ++jobId;
            workerJobs[id] = resolve;
            w.postMessage({ id: id, url: key, t: KO_T, crop: !!crop });
          })
        : processOnMainThread(key, crop);
      return job.then(function (res) {
        if ('caches' in window && res.status !== 'error') {
          caches.open(cacheName).then(function (c) {
            var body = res.status === 'done' ? res.blob : new Blob(['']);
            c.put(key, new Response(body, { headers: { 'x-ko': res.status, 'Content-Type': res.status === 'done' ? res.blob.type : 'text/plain' } }));
          }).catch(function () {});
        }
        return res;
      });
    });
  }

  function whenLoaded(img) {
    return new Promise(function (resolve) {
      if (img.complete && img.naturalWidth) return resolve();
      img.addEventListener('load', function () { resolve(); }, { once: true });
      img.addEventListener('error', function () { resolve(); }, { once: true });
    });
  }

  function knockoutImg(img, container, isHover) {
    if (img.dataset.koState) return Promise.resolve();
    img.dataset.koState = 'busy';
    // Force the lazy image to start loading so currentSrc is known
    if (img.loading === 'lazy' && isHover) img.loading = 'eager';
    return whenLoaded(img).then(function () {
      var src = img.currentSrc || img.src;
      if (!src || !img.naturalWidth) throw new Error('no src');
      // Product page gallery + zoom keep the full frame; everywhere else products are cropped tight
      return knockoutUrl(src, !container.closest('[data-gallery], .zoom-dialog'));
    }).then(function (res) {
      if (res.status === 'done') {
        var obj = URL.createObjectURL(res.blob);
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = obj;
        img.dataset.koState = 'done';
        return whenLoaded(img).then(function () {
          container.classList.add(isHover ? 'ko-hover-ready' : 'ko-done');
        });
      }
      img.dataset.koState = res.status;
      if (res.status === 'skip') container.classList.add(isHover ? 'ko-hover-ready' : 'ko-skip');
      else if (!isHover) container.classList.add('ko-failed');
    }).catch(function () {
      img.dataset.koState = 'fail';
      if (!isHover) container.classList.add('ko-failed');
    });
  }

  var koObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      koObserver.unobserve(en.target);
      runKnockout(en.target);
    });
  }, { rootMargin: '300px 0px' }) : null;

  function runKnockout(container) {
    var imgs = $$('img', container);
    var main = imgs.filter(function (i) { return !i.classList.contains('card__img--hover'); });
    var hover = imgs.filter(function (i) { return i.classList.contains('card__img--hover'); })[0];
    if (!main.length) { container.classList.add('ko-skip'); return; }
    main.forEach(function (img) { knockoutImg(img, container, false); });
    if (hover && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      container.addEventListener('mouseenter', function () { knockoutImg(hover, container, true); }, { once: true });
    }
  }

  function processKnockouts(root) {
    $$('.knockout', root || document).forEach(function (c) {
      if (c.dataset.koBound) return;
      c.dataset.koBound = '1';
      if (koObserver) koObserver.observe(c); else runKnockout(c);
    });
  }
  T.processKnockouts = processKnockouts;

  /* ---------------------------------------------------------------------------
     Auto-fill: real product imagery / grids for sections that have no collection yet
     [data-fill-query="dior"]  -> first product image from store search (tiny section)
     [data-fill-grid="url"]    -> product cards from a Section Rendering URL
     ------------------------------------------------------------------------- */
  var fillCache = {};
  function fetchHTML(url) {
    if (!fillCache[url]) {
      fillCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    return fillCache[url];
  }

  function fillQuery(el) {
    var url = T.routes.search + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(el.dataset.fillQuery) + '&section_id=search-first';
    fetchHTML(url).then(function (doc) {
      var img = doc.querySelector('[data-first] img');
      if (!img) { el.classList.add('is-empty'); return; }
      var node = document.importNode(img, true);
      if (el.hasAttribute('data-fill-eager')) node.loading = 'eager';
      el.appendChild(node);
      if (el.classList.contains('knockout-deferred')) {
        el.classList.remove('knockout-deferred');
        el.classList.add('knockout');
        processKnockouts(el.parentNode);
      } else {
        el.classList.add('is-filled');
      }
    }).catch(function () { el.classList.add('is-empty'); });
  }

  function fillGrid(el) {
    var limit = parseInt(el.dataset.limit, 10) || 8;
    fetchHTML(el.dataset.fillGrid).then(function (doc) {
      var list = doc.querySelector('[data-page-items]');
      if (!list) return;
      var items = Array.prototype.slice.call(list.children, 0, limit);
      if (!items.length) return;
      el.innerHTML = '';
      items.forEach(function (li) { el.appendChild(document.importNode(li, true)); });
      el.setAttribute('aria-busy', 'false');
      document.dispatchEvent(new CustomEvent('moood:content', { detail: { root: el } }));
    }).catch(function () {});
  }

  var fillIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      fillIO.unobserve(en.target);
      if (en.target.hasAttribute('data-fill-grid')) fillGrid(en.target); else fillQuery(en.target);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function autoFill(root) {
    $$('[data-fill-query], [data-fill-grid]', root || document).forEach(function (el) {
      if (el.dataset.fillBound) return;
      el.dataset.fillBound = '1';
      if (el.hasAttribute('data-fill-eager') || !fillIO) {
        if (el.hasAttribute('data-fill-grid')) fillGrid(el); else fillQuery(el);
      } else {
        fillIO.observe(el);
      }
    });
  }

  /* ---------------------------------------------------------------------------
     Init + hooks for dynamically inserted content
     ------------------------------------------------------------------------- */
  function purgeOldKnockoutCaches() {
    if (!('caches' in window) || !caches.keys) return;
    caches.keys().then(function (keys) {
      keys.forEach(function (k) {
        if (k.indexOf('moood-ko-') === 0 && k.indexOf(KO_CACHE) !== 0) caches.delete(k);
      });
    }).catch(function () {});
  }

  function init() {
    setTimeout(purgeOldKnockoutCaches, 4000);
    autoFill(document);
    reveal(document);
    processKnockouts(document);
    freeShipping();
  }
  document.addEventListener('moood:content', function (e) { reveal(e.detail && e.detail.root); processKnockouts(e.detail && e.detail.root); });
  document.addEventListener('shopify:section:load', function (e) { autoFill(e.target); reveal(e.target); processKnockouts(e.target); freeShipping(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  T.openDrawer = openDrawer;
  T.closeLayer = closeLayer;
  T.renderCartSections = renderCartSections;
})();
